import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
import { toFlexContainerClassName, toFlexItemClassName, } from '../../utils/FlexboxUtils.js';
import { toSpacingClassName } from '../../utils/LayoutPropsUtils.js';
export const Column = ({ className, style, children, ...props }) => {
    return (_jsx("div", { className: toClassName(className, toFlexContainerClassName({ ...props, flexDirection: 'column' }), toSpacingClassName(props)), style: style, children: children }));
};
Column.displayName = 'Column';
Column.Item = ({ className, style, children, ...props }) => {
    return (_jsx("div", { className: toClassName(className, toFlexItemClassName(props)), style: style, children: children }));
};
Column.Item.displayName = 'Column.Item';
//# sourceMappingURL=Column.js.map